export default __webpack_public_path__ + "static/media/uv0_en_jing_b3.9117318e.mp3";